import React, { useState, useRef, useCallback } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export default function GurgencilerDunyaKupasi2026() {
  const [activeOption, setActiveOption] = useState('A');
  const [exporting, setExporting] = useState(false);
  const captureRef = useRef(null);

  const handleExportPDF = useCallback(async () => {
    if (exporting) return;
    setExporting(true);
    try {
      const el = captureRef.current;
      if (!el) return;

      await Promise.all(
        Array.from(el.querySelectorAll('img')).map(img => {
          if (img.complete && img.naturalWidth > 0) return Promise.resolve();
          return new Promise(resolve => {
            const done = () => resolve();
            img.addEventListener('load', done, { once: true });
            img.addEventListener('error', done, { once: true });
          });
        })
      );

      const canvas = await html2canvas(el, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        windowWidth: 1280,
        letterRendering: true,
        allowTaint: true,
        imageTimeout: 15000,
      });

      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();
      const margin = 8;
      const usableW = pageW - margin * 2;
      const usableH = pageH - margin * 2;
      const pxPerMm = canvas.width / usableW;
      const pageHpx = usableH * pxPerMm;

      let posY = 0;
      let pageIndex = 0;
      while (posY < canvas.height) {
        if (pageIndex > 0) pdf.addPage();
        const sliceH = Math.min(pageHpx, canvas.height - posY);
        const sliceCanvas = document.createElement('canvas');
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = sliceH;
        const ctx = sliceCanvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
        ctx.drawImage(canvas, 0, -posY);
        const imgData = sliceCanvas.toDataURL('image/jpeg', 0.92);
        const drawH = sliceH / pxPerMm;
        pdf.addImage(imgData, 'JPEG', margin, margin, usableW, drawH);
        posY += pageHpx;
        pageIndex++;
      }

      const optLabel = activeOption === 'A' ? 'Opsiyon_A' : 'Opsiyon_B';
      pdf.save(`Gurgencler_Dunya_Kupasi_2026_${optLabel}.pdf`);
    } catch (err) {
      console.error('PDF export failed:', err);
      alert('PDF export sırasında hata oluştu. Konsolu kontrol et.');
    } finally {
      setExporting(false);
    }
  }, [exporting, activeOption]);

  const optionA = {
    name: 'Opsiyon A — Türkiye Odaklı',
    desc: 'Bütçenin %60’ı grup maçlarına. YouTube + Programatik ağırlıklı. Knockout fazları Türkiye’nin geçişine göre conditional açılır.',
    channels: { youtube: 350000, programmatic: 300000, meta: 200000, tiktok: 150000 },
  };
  const optionB = {
    name: 'Opsiyon B — Maksimum Frekans',
    desc: 'Bütçenin %75’i grup ve friendly maçlarına. Knockout’a sembolik bütçe. Türkiye gruptan çıkamazsa kayıp minimum.',
    channels: { youtube: 380000, programmatic: 320000, meta: 180000, tiktok: 120000 },
  };
  const opt = activeOption === 'A' ? optionA : optionB;
  const total = Object.values(opt.channels).reduce((a, b) => a + b, 0);

  const phases = activeOption === 'A'
    ? [
        { label: 'Warmup / Friendlies', dates: '25 Mayıs → 13 Haziran',   share: 10, budget: 100000 },
        { label: 'Grup Maçları (D)',    dates: '14 Haziran → 26 Haziran', share: 60, budget: 600000, highlight: true },
        { label: 'Son 16',              dates: '28 Haziran → 3 Temmuz',   share: 12, budget: 120000 },
        { label: 'Çeyrek Final',        dates: '9 → 11 Temmuz',           share: 8,  budget: 80000 },
        { label: 'Yarı Final',          dates: '14 → 15 Temmuz',          share: 6,  budget: 60000 },
        { label: 'Final / 3.lük',       dates: '18 → 19 Temmuz',          share: 4,  budget: 40000 },
      ]
    : [
        { label: 'Warmup / Friendlies', dates: '25 Mayıs → 13 Haziran',   share: 15, budget: 150000 },
        { label: 'Grup Maçları (D)',    dates: '14 Haziran → 26 Haziran', share: 75, budget: 750000, highlight: true },
        { label: 'Son 16',              dates: '28 Haziran → 3 Temmuz',   share: 5,  budget: 50000 },
        { label: 'Çeyrek Final',        dates: '9 → 11 Temmuz',           share: 3,  budget: 30000 },
        { label: 'Yarı Final',          dates: '14 → 15 Temmuz',          share: 1,  budget: 10000 },
        { label: 'Final / 3.lük',       dates: '18 → 19 Temmuz',          share: 1,  budget: 10000 },
      ];

  const matches = [
    { date: '1 Haziran',  time: 'TBD',        type: 'Hazırlık', home: 'Türkiye',    away: 'K.Makedonya' },
    { date: '7 Haziran',  time: '01:00 (TR)', type: 'Hazırlık', home: 'Venezuela',  away: 'Türkiye' },
    { date: '14 Haziran', time: '06:00 (TR)', type: 'Grup D',   home: 'Avustralya', away: 'Türkiye' },
    { date: '20 Haziran', time: '05:00 (TR)', type: 'Grup D',   home: 'Türkiye',    away: 'Paraguay' },
    { date: '26 Haziran', time: '04:00 (TR)', type: 'Grup D',   home: 'Türkiye',    away: 'USA' },
  ];

  const matchCluster = [
    { window: 'Maç Öncesi Buzz',         day: 'T-3 → T-1',   share: 35, focus: 'Hype, kadro/skor tahmini, ürün hediyeli engagement, “maça hazır mısın?” iletişimi.' },
    { window: 'Maç Günü',                 day: 'T-0',         share: 30, focus: 'Reach + frekans patlaması. Canlı yayın komşusu YouTube/TikTok içerikleri, sosyal anlık tepki.' },
    { window: 'Sabah Özet Penceresi',     day: 'T+1 sabah',   share: 25, focus: 'Erken saatte oynanan maçın özetleri (YouTube highlights, TikTok klip, GDN spor sayfaları) içinde retargeting.' },
    { window: 'Maç Sonrası — Teşekkürler', day: 'T+1 → T+2',   share: 10, focus: 'Galip/mağlup ayrı yaratıcılarla. Mağaza ve ürün bağlantısı, in-store traffic.' },
  ];

  const channelByPhase = activeOption === 'A'
    ? [
        { phase: 'Warmup', youtube: 45000,  programmatic: 25000,  meta: 20000,  tiktok: 10000, sum: 100000 },
        { phase: 'Grup D', youtube: 200000, programmatic: 200000, meta: 110000, tiktok: 90000, sum: 600000, highlight: true },
        { phase: 'Son 16', youtube: 45000,  programmatic: 40000,  meta: 20000,  tiktok: 15000, sum: 120000 },
        { phase: 'ÇF',     youtube: 30000,  programmatic: 25000,  meta: 15000,  tiktok: 10000, sum: 80000 },
        { phase: 'YF',     youtube: 20000,  programmatic: 15000,  meta: 15000,  tiktok: 10000, sum: 60000 },
        { phase: 'Final',  youtube: 10000,  programmatic: 10000,  meta: 10000,  tiktok: 10000, sum: 40000 },
      ]
    : [
        { phase: 'Warmup', youtube: 60000,  programmatic: 45000,  meta: 30000,  tiktok: 15000, sum: 150000 },
        { phase: 'Grup D', youtube: 280000, programmatic: 245000, meta: 130000, tiktok: 95000, sum: 750000, highlight: true },
        { phase: 'Son 16', youtube: 20000,  programmatic: 15000,  meta: 10000,  tiktok: 5000,  sum: 50000 },
        { phase: 'ÇF',     youtube: 12000,  programmatic: 10000,  meta: 5000,   tiktok: 3000,  sum: 30000 },
        { phase: 'YF',     youtube: 4000,   programmatic: 3000,   meta: 2000,   tiktok: 1000,  sum: 10000 },
        { phase: 'Final',  youtube: 4000,   programmatic: 2000,   meta: 3000,   tiktok: 1000,  sum: 10000 },
      ];

  const audiences = [
    {
      title: 'A Milli Takım Sıkı Taraftarları',
      meta: '25–55 erkek · futbol affinity yüksek · Türkiye yıl boyu izleyici',
      bullets: [
        'Meta: TFF, A Milli Takım, Çalhanoğlu, Arda Güler, BJK/FB/GS sayfa takipçileri',
        'YouTube: Spor kanalları (TRT Spor, A Spor, beIN) ve milli maç özet videoları izleyicisi',
        'Programatik: NTV Spor, Fanatik, Goal.com, Sözcü Spor ziyaretçileri (1P data + DSP segment)',
      ],
      size: '~9.5M',
      share: '%28',
    },
    {
      title: 'Premium Spor Tutkunu Genç Profesyonel',
      meta: '28–45 · yüksek gelir · İstanbul / Ankara / İzmir 3 büyükşehir ağırlıklı',
      bullets: [
        'Meta: Lookalike — mevcut Gürgençler müşterileri + Apple Store TR ziyaretçileri',
        'YouTube: Premium spor + tech (MKBHD, Verge, beIN highlights) viewer’ları',
        'Programatik: Habertürk, NTV, Bloomberg HT, Webrazzi affinity audiences',
      ],
      size: '~2.8M',
      share: '%20',
    },
    {
      title: 'iPhone Upgrade-Ready Segment',
      meta: 'iPhone 12 / 13 / 14 sahibi · 3–4 yıllık cihaz · yenileme intent sinyali yüksek',
      bullets: [
        'Meta: Device-targeting eski iPhone modelleri + “iPhone 17”, “Trade-in” aramaları',
        'YouTube: iPhone karşılaştırma / inceleme video viewer’ları',
        'Programatik: Sahibinden, Hepsiburada, Trendyol Apple kategorisi ziyaretçileri (DSP retarget)',
      ],
      size: '~3.4M',
      share: '%18',
    },
    {
      title: 'Aile Babası Futbol İzleyicisi',
      meta: '35–55 erkek · evli · 8–18 yaş çocuğu var · aile için Apple alıcısı',
      bullets: [
        'Meta: Parents + sports interest + “çocuk için iPad/AirPods” arayanlar',
        'YouTube: Maç önü/özet videoları + aile / lifestyle channels',
        'Programatik: Ekşi Sözlük spor başlıkları, Sözcü, Hürriyet aile/spor sayfaları',
      ],
      size: '~4.1M',
      share: '%14',
    },
    {
      title: 'Gen-Z Yaratıcı · Taksit Hassas',
      meta: '18–28 · üniversite / yeni mezun · TikTok heavy · ilk iPhone hayali',
      bullets: [
        'TikTok: #DünyaKupası, #FutbolEdit, futbol meme + Apple unboxing creator follower’ları',
        'Meta Reels: Spor + müzik + lifestyle Gen-Z affinity, “taksit” / “öğrenci kredisi” iletişimi',
        'YouTube Shorts: Maç highlights + tech short-form viewer’ları',
      ],
      size: '~6.7M',
      share: '%12',
    },
    {
      title: 'Apple Ekosistem Sadıkları',
      meta: '5+ yıllık Apple kullanıcı · multi-device (iPhone + iPad + Watch + AirPods)',
      bullets: [
        'Meta: Gürgençler CRM 1P data + Apple Store TR co-affinity lookalike',
        'YouTube: Apple Event watcher’lar + tech review premium audience (top 10% LTV)',
        'Programatik: Donanım Haber, Tamindir, Webrazzi Apple kategorisi · in-market premium tech',
      ],
      size: '~1.2M',
      share: '%8',
    },
  ];

  const placements = [
    {
      letter: 'A',
      title: 'Programatik / Display — TR Spor Yayıncıları',
      sub: 'GDN + DV360 + The Trade Desk üzerinden direct + premium PMP. Maç önizleme, canlı ve maç sonu yorum sayfaları.',
      items: [
        'NTV Spor (ntvspor.net)', 'A Spor (aspor.com.tr)', 'TRT Spor (trtspor.com.tr)', 'beIN Sports TR',
        'Fanatik (fanatik.com.tr)', 'Goal Türkiye (goal.com)', 'Sporx (sporx.com)', 'Skorer / Milliyet Spor',
        'Sözcü Spor', 'Hürriyet Spor', 'Sabah Spor / Takvim', 'Sporokur',
        'Mackolik (mackolik.com)', 'Tribün Dergi', 'Onedio Spor', 'Ekşi Sözlük spor entry’leri',
      ],
      footer: 'Maç günü kontekstüel: Sport vertical IAB taxonomy 17 · keyword targeting (“Türkiye maç”, “maç özeti”, “Grup D”).',
    },
    {
      letter: 'B',
      title: 'YouTube — Maç Öncesi & Yorum Kanalları',
      sub: 'Kadro açıklaması, taktik analiz, maç önizleme content’lerinin yanında preroll / midroll. T-3 → T-0 penceresinde frekans.',
      items: [
        'TRT Spor ve A Spor resmi YT kanalları',
        'beIN SPORTS Türkiye — Pazar Panorama, yorum programları',
        'NTV Spor ve Goal Türkiye',
        'Mehmet Demirkol — Açıkkonuş (~1.4M abone, premium yorum)',
        'Maçın Adamı — Mehmet Aurelio (yorum + analiz)',
        'Şampiyon Ozan (taraftar reaksiyon, yüksek engagement)',
        'Sercan Dikme, Onur Tuğrul Sportingulus, Adı Maç',
        'Skorer TV, Hakan Yeşil kanalları',
        'Acun Ilıcalı Söğüt spor podcast YT bölümleri',
        'Kulüp resmi kanalları (GS / FB / BJK)',
      ],
      footer: 'Format: Skippable in-stream 15–30s · 6s Bumper · YT Shorts vertical 9:16.',
    },
    {
      letter: 'C',
      title: 'YouTube — Maç Özetleri & Highlights',
      sub: 'Maç 04:00–06:00 saatleri arasında oynanıyor. İzleyicinin %70+’ı sabah özet videolarında yakalanacak. Bu pencere bütçenin %25’ini alır.',
      items: [
        'FIFA TV Official (resmi WC26 highlights — global brand lift halo)',
        'TRT Spor Official (TR resmi yayın hakları, en yüksek izlenme)',
        'A Spor ve beIN SPORTS Türkiye highlights',
        'TFF — Türkiye Futbol Federasyonu resmi kanal',
        'Goal Türkiye, Sporx, Fanatik özet kompilasyonları',
        'ESPN FC ve OneFootball Türkiye ilgisi yüksek videolar',
        'A Milli Takım gol kompilasyonları (UGC + resmi)',
        'Yıldız oyuncu (Çalhanoğlu, Güler, Yıldız) bireysel highlight videoları',
        'YouTube Shorts: #GrupD özet klipleri trend feed',
      ],
      footer: 'Bidding: Target CPM + Brand Lift Study aktif · Premium spor inventory pre-bid.',
    },
    {
      letter: 'D',
      title: 'Sosyal Medya — Creator & UGC',
      sub: 'Spark Ads / Branded Content boost ile creator’ların organik içerikleri reklam olarak yayınlanır. Anlık reaksiyon + maç sonu meme cycle.',
      items: [
        '@futbolarena, @forveotr, @sporx Instagram ve TikTok hesapları',
        '@futbol_haberlerim, @fanatikspor, @asporcomtr',
        'Futbol meme creator’ları: @orjinalfutbolculer, @taktikboard',
        'Reaksiyon TikToker’lar: maç anı canlı reaksiyon + sabah özet reaksiyon',
        'Apple / tech creator overlap: @batuhanyildirim, @tarcantopal, @umithanay',
        'Hashtag bidding (TikTok TopView + Branded Hashtag Challenge):',
        '#DünyaKupası2026 · #MilliTakım · #GrupD · #TeşekkürlerTürkiye · #GürgençlerileTürkiye',
        'Resmi futbolcu/teknik kadro hesaplarının Instagram Reels post-engagement retarget',
      ],
      footer: 'Hız: Maç sonu reaksiyon videoları en geç T+2 saat içinde Spark Ads olarak boost edilir.',
    },
  ];

  const fmt = (n) => `₺${Math.round(n).toLocaleString('tr-TR')}`;
  const fmtK = (n) => `₺${(n / 1000).toFixed(0)}K`;

  return (
    <div className="p-6 max-w-7xl mx-auto bg-white">

      {/* PDF EXPORT BUTTON — capture dışında, PDF'e girmez */}
      <div className="flex justify-end mb-4">
        <button
          onClick={handleExportPDF}
          disabled={exporting}
          className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded border transition ${exporting ? 'bg-gray-100 text-gray-400 cursor-wait border-gray-200' : 'bg-white text-gray-900 hover:bg-gray-50 border-gray-300'}`}
        >
          {exporting ? 'PDF Hazırlanıyor…' : 'PDF olarak indir'}
        </button>
      </div>

      <div ref={captureRef} className="bg-white text-gray-900 space-y-8">

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* HERO                                                                 */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div className="border-b border-gray-300 pb-6">
          <div className="flex items-center gap-5 mb-6">
            <img
              src="/gurgencler-logo.svg"
              alt="Gürgençler"
              className="h-10 w-auto object-contain"
            />
            <div className="text-gray-300 text-xl font-light select-none">×</div>
            <img
              src="/wc26-logo.png"
              alt="FIFA World Cup 2026"
              className="h-12 w-auto object-contain"
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-gray-500 mb-2">FIFA World Cup 2026 · USA · Canada · Mexico</div>
              <h1 className="text-3xl sm:text-4xl font-bold leading-tight text-gray-900">Dünya Kupası 2026 Medya Planı</h1>
              <p className="text-sm text-gray-600 mt-2">Meta · TikTok · YouTube · Programatik — Türkiye Grup D odaklı kampanya · 25 Mayıs – 19 Temmuz 2026</p>
            </div>
            <div className="text-right shrink-0">
              <div className="text-[11px] uppercase tracking-wider text-gray-500">Toplam Bütçe</div>
              <div className="text-3xl font-bold text-gray-900 mt-1">₺{(total / 1000000).toFixed(1)}M</div>
            </div>
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* OPSİYONLAR                                                           */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-3 gap-2">
            <h2 className="text-base font-semibold text-gray-900">Plan Opsiyonları</h2>
            <div className="flex gap-2">
              <button
                onClick={() => setActiveOption('A')}
                className={`px-3 py-1.5 text-xs font-medium rounded border ${activeOption === 'A' ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
              >
                Opsiyon A
              </button>
              <button
                onClick={() => setActiveOption('B')}
                className={`px-3 py-1.5 text-xs font-medium rounded border ${activeOption === 'B' ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
              >
                Opsiyon B
              </button>
            </div>
          </div>
          <div className="border border-gray-200 rounded p-4">
            <div className="text-sm font-semibold text-gray-900">{opt.name}</div>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">{opt.desc}</p>
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* KANAL ÖZET                                                           */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-3">Kanal Dağılımı</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { name: 'YouTube',     value: opt.channels.youtube,      desc: 'Skippable + Bumper + Masthead + Shorts' },
              { name: 'Programatik', value: opt.channels.programmatic, desc: 'GDN + DSP, spor + özet siteleri' },
              { name: 'Meta',        value: opt.channels.meta,         desc: 'Reels + Stories + Feed Video' },
              { name: 'TikTok',      value: opt.channels.tiktok,       desc: 'TopView + In-Feed + Spark Ads' },
            ].map((c) => (
              <div key={c.name} className="border border-gray-200 rounded p-4">
                <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">{c.name}</div>
                <div className="text-xl font-bold text-gray-900 mt-1">{fmt(c.value)}</div>
                <div className="text-[11px] text-gray-600 mt-1">%{Math.round(c.value / total * 100)} · {c.desc}</div>
                <div className="mt-3 h-1 bg-gray-100">
                  <div className="h-full bg-gray-900" style={{ width: `${c.value / total * 100}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* TIMELINE                                                             */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">Turnuva Timeline & Bütçe Dağılımı</h2>
          <p className="text-xs text-gray-600 mb-4">Bütçenin büyük kısmı grup maçlarına. Knockout fazları Türkiye’nin geçişine göre conditional açılır.</p>

          <div className="overflow-x-auto pb-2 mb-4">
            <div className="flex gap-px min-w-[900px] border border-gray-300">
              {phases.map((p, i) => (
                <div
                  key={i}
                  className={`p-3 flex flex-col justify-between border-r border-gray-200 last:border-r-0 ${p.highlight ? 'bg-gray-100' : 'bg-white'}`}
                  style={{ flex: p.share, minHeight: '100px' }}
                >
                  <div>
                    <div className="text-[10px] font-semibold uppercase tracking-wider text-gray-900">{p.label}</div>
                    <div className="text-[10px] text-gray-500 mt-0.5">{p.dates}</div>
                  </div>
                  <div className="mt-2">
                    <div className={`text-base font-bold ${p.highlight ? 'text-gray-900' : 'text-gray-700'}`}>{fmtK(p.budget)}</div>
                    <div className="text-[10px] text-gray-500">%{p.share}</div>
                    <div className={`h-0.5 mt-1.5 ${p.highlight ? 'bg-gray-900' : 'bg-gray-400'}`} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <p className="text-[11px] text-gray-600 leading-relaxed">
            Knockout fazları (Son 16 → Final) Türkiye’nin geçişine göre aktif olur. Türkiye elenirse rezerv bütçe always-on retail SoV kampanyasına veya turnuvanın yıldız oyuncularına (Messi/Mbappé/Bellingham) bağlı creative ile gevşek frekansa aktarılır.
          </p>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* MAÇ TAKVİMİ                                                          */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">A Milli Takım Maç Takvimi</h2>
          <p className="text-xs text-gray-600 mb-4">2 hazırlık + 3 Grup D maçı. Tüm maçlar gece geç saat / sabah erken — özet pencereleri kritik.</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-2">
            {matches.map((m, i) => {
              const isGroup = m.type === 'Grup D';
              return (
                <div key={i} className={`border p-3 rounded ${isGroup ? 'border-gray-900 bg-white' : 'border-gray-200 bg-white'}`}>
                  <div className="flex items-center justify-between mb-2">
                    <span className={`text-[10px] font-medium uppercase tracking-wider px-1.5 py-0.5 rounded ${isGroup ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-700'}`}>
                      {m.type}
                    </span>
                    <span className="text-[10px] text-gray-500">{m.time}</span>
                  </div>
                  <div className="text-xs font-medium text-gray-700 mb-2">{m.date}</div>
                  <div className="space-y-0.5">
                    <div className={`text-sm ${m.home === 'Türkiye' ? 'font-bold text-gray-900' : 'text-gray-700'}`}>{m.home}</div>
                    <div className="text-[10px] text-gray-400">vs</div>
                    <div className={`text-sm ${m.away === 'Türkiye' ? 'font-bold text-gray-900' : 'text-gray-700'}`}>{m.away}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* KANAL × FAZ MATRİSİ                                                  */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">Kanal × Faz Bütçe Matrisi</h2>
          <p className="text-xs text-gray-600 mb-3">Her satır turnuva fazı, her sütun kanal. Toplam = ₺{(total / 1000000).toFixed(1)}M.</p>

          <div className="overflow-x-auto border border-gray-200 rounded">
            <table className="min-w-full">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="px-4 py-2.5 text-left text-[11px] font-semibold text-gray-700 uppercase tracking-wider">Faz</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-semibold text-gray-700 uppercase tracking-wider">YouTube</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-semibold text-gray-700 uppercase tracking-wider">Programatik</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-semibold text-gray-700 uppercase tracking-wider">Meta</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-semibold text-gray-700 uppercase tracking-wider">TikTok</th>
                  <th className="px-4 py-2.5 text-right text-[11px] font-semibold text-gray-700 uppercase tracking-wider">Faz Toplamı</th>
                </tr>
              </thead>
              <tbody>
                {channelByPhase.map((row, i) => (
                  <tr key={i} className={`border-b border-gray-100 last:border-b-0 ${row.highlight ? 'bg-gray-50' : 'bg-white'}`}>
                    <td className={`px-4 py-2.5 text-sm ${row.highlight ? 'font-semibold text-gray-900' : 'text-gray-700'}`}>{row.phase}</td>
                    <td className="px-4 py-2.5 text-sm text-right text-gray-700">{fmt(row.youtube)}</td>
                    <td className="px-4 py-2.5 text-sm text-right text-gray-700">{fmt(row.programmatic)}</td>
                    <td className="px-4 py-2.5 text-sm text-right text-gray-700">{fmt(row.meta)}</td>
                    <td className="px-4 py-2.5 text-sm text-right text-gray-700">{fmt(row.tiktok)}</td>
                    <td className={`px-4 py-2.5 text-sm text-right ${row.highlight ? 'font-bold text-gray-900' : 'font-medium text-gray-800'}`}>{fmt(row.sum)}</td>
                  </tr>
                ))}
                <tr className="border-t-2 border-gray-900 bg-white">
                  <td className="px-4 py-2.5 text-sm font-bold text-gray-900">Toplam</td>
                  <td className="px-4 py-2.5 text-sm text-right font-bold text-gray-900">{fmt(opt.channels.youtube)}</td>
                  <td className="px-4 py-2.5 text-sm text-right font-bold text-gray-900">{fmt(opt.channels.programmatic)}</td>
                  <td className="px-4 py-2.5 text-sm text-right font-bold text-gray-900">{fmt(opt.channels.meta)}</td>
                  <td className="px-4 py-2.5 text-sm text-right font-bold text-gray-900">{fmt(opt.channels.tiktok)}</td>
                  <td className="px-4 py-2.5 text-sm text-right font-bold text-gray-900">{fmt(total)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* MAÇ CLUSTER ALOKASYONU                                               */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">Türkiye Grup D Maçı — Cluster Alokasyonu</h2>
          <p className="text-xs text-gray-600 mb-4">
            Her Türkiye grup maçı için yaklaşık ₺200K 4 pencereye dağıtılır. Maç saatleri 04:00–06:00 — sabah özet penceresi kritik.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            {matchCluster.map((c, i) => (
              <div key={i} className="border border-gray-200 rounded p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[10px] font-medium uppercase tracking-wider text-gray-500">{c.day}</span>
                  <span className="text-xs font-semibold text-gray-900">%{c.share}</span>
                </div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">{c.window}</h3>
                <div className="h-1 bg-gray-100 mb-3">
                  <div className="h-full bg-gray-900" style={{ width: `${c.share * 2.5}%` }} />
                </div>
                <p className="text-[11px] text-gray-600 leading-relaxed">{c.focus}</p>
                <div className="mt-3 pt-3 border-t border-gray-100 text-[11px] text-gray-500">
                  Maç başı bütçe: <span className="font-medium text-gray-900">{fmt(200000 * c.share / 100)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* AUDIENCE SEGMENTLERİ                                                 */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">Hedef Audience Segmentleri</h2>
          <p className="text-xs text-gray-600 mb-4">6 spesifik kitleye paralel kampanyalarla ulaşılacak. Her segmente kanal × creative kombinasyonu özel.</p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {audiences.map((a, i) => (
              <div key={i} className="border border-gray-200 rounded p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 rounded-sm bg-gray-900 text-white flex items-center justify-center text-[11px] font-bold">{i + 1}</span>
                  <h3 className="text-sm font-semibold text-gray-900">{a.title}</h3>
                </div>
                <p className="text-[11px] text-gray-500 mb-3">{a.meta}</p>
                <ul className="text-[11px] text-gray-700 space-y-1 leading-relaxed">
                  {a.bullets.map((b, j) => <li key={j}>· {b}</li>)}
                </ul>
                <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between text-[11px] text-gray-500">
                  <span>{a.size} kişi</span>
                  <span>Bütçe payı: <span className="font-medium text-gray-900">{a.share}</span></span>
                </div>
              </div>
            ))}
          </div>

          <div className="border border-gray-200 rounded p-3 mt-3 text-[11px] text-gray-600 flex items-center justify-between flex-wrap gap-2">
            <div><span className="font-semibold text-gray-900">Toplam erişilebilir audience:</span> ~27.7M tekil · Türkiye 18+ futbol-affinity nüfusunun %78’i</div>
            <div>Overlap suppression: Segment 6 → 1 → 3 → 2 → 4 → 5</div>
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* PLACEMENT STRATEJİSİ                                                 */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">Placement & Publisher Stratejisi</h2>
          <p className="text-xs text-gray-600 mb-4">Programatik DSP whitelist + YouTube content cluster + sosyal medya creator listesi. Maç öncesi / maç günü / sabah özet pencerelerine göre dağıtılır.</p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
            {placements.map((p, i) => (
              <div key={i} className="border border-gray-200 rounded p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 rounded-sm bg-gray-900 text-white flex items-center justify-center text-[11px] font-bold">{p.letter}</span>
                  <h3 className="text-sm font-semibold text-gray-900">{p.title}</h3>
                </div>
                <p className="text-[11px] text-gray-500 mb-3">{p.sub}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1 text-[11px] text-gray-700">
                  {p.items.map((it, j) => <div key={j}>· {it}</div>)}
                </div>
                <div className="mt-3 pt-3 border-t border-gray-100 text-[11px] text-gray-600">{p.footer}</div>
              </div>
            ))}
          </div>

          <div className="border border-gray-200 rounded p-3 mt-3 text-[11px] text-gray-700 leading-relaxed">
            <span className="font-semibold text-gray-900">Brand-safety negative list:</span> Bahis siteleri (iddaa olmayan), şiddet/küfür yorumlar, taraftar grubu sayfalarındaki kavga klipleri, hakem hakaret içeriği, anti-takım nefret kanalları. DV360 sensitive categories + GARM Brand Safety Floor + custom keyword blocklist (otomatik kapatma).
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* CREATIVE PILLARS                                                     */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">İletişim & Creative Pillars</h2>
          <p className="text-xs text-gray-600 mb-4">Her faz için iki yaratıcı yol — “galip” ve “mağlup” varyantları her zaman hazır olur.</p>

          <div className="space-y-3">
            {[
              {
                num: '1', title: 'Maç Öncesi — Hype & Empati',
                items: [
                  '“Maça hazır mısın?” — iPhone hediyeli skor tahmini engagement (Meta + TikTok)',
                  'Apple Watch ile takip et: kalp atışı, statistik — sport tech tie-in',
                  'YouTube preroll: 15s teaser, milli takım maç günü reklam paketi',
                  'Programatik: spor portalları (NTVSpor, Fanatik, Goal.com) maç önizleme sayfaları',
                ]
              },
              {
                num: '2', title: 'Maç Günü — Anlık Tepki',
                items: [
                  'Real-time creative: ilk gol, kritik kurtarış sonrası 15 dakika içinde TikTok/Reels post',
                  'Programatik: ESPN, Goal, BeIN, TRT digital, sosyal medya “matchday” takviyesi',
                  'Story polls: “2. yarıda kim sahaya?” — engagement spike',
                  'YouTube live + on-demand: maç sırasında YT Shorts trend, second-screen davranışı',
                ]
              },
              {
                num: '3', title: 'Sabah Özet Penceresi (Kritik)',
                items: [
                  'YouTube highlights kanalları (TRT Spor, A Spor, FIFA, Beşiktaş JK vb.) preroll/midroll ağırlığı',
                  'TikTok hashtag bidding: #DünyaKupası #Türkiye #GrupD — özet kliplerin yanı',
                  'GDN: spor haber sitelerinde “maç özeti”, “maç sonu yorumu” kategori sayfaları',
                  'Meta Reels: özet montaj reels’lerin yanına in-feed ad',
                  'Maçlar 04:00–06:00 (TR). Hedef kitle %70+ canlı izlemeyecek → bütçenin %25’i burada.',
                ]
              },
              {
                num: '4', title: 'Maç Sonrası — Teşekkürler Türkiye',
                items: [
                  'Galip senaryosu: “Türkiye’nin yanında olduğunuz için teşekkürler” + mağaza/ürün CTA',
                  'Mağlubiyet senaryosu: “Yine de gururumuzsunuz” — empatik ton, dolaylı mağaza CTA',
                  'Mağaza traffic odaklı Performance Max + Meta Sales kreatif aktivasyonu (sabah 09:00–13:00)',
                  'Apple ekosistemi tie-in: “Maçı kaçırdın mı? AirPods ile özet, Apple TV ile tekrar izle”',
                ]
              },
            ].map((p, i) => (
              <div key={i} className="border border-gray-200 rounded p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 rounded-sm bg-gray-900 text-white flex items-center justify-center text-[11px] font-bold">{p.num}</span>
                  <h3 className="text-sm font-semibold text-gray-900">{p.title}</h3>
                </div>
                <ul className="text-[12px] text-gray-700 space-y-1 ml-8 leading-relaxed">
                  {p.items.map((it, j) => <li key={j}>· {it}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* KPI PROJEKSİYONLARI                                                  */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div>
          <h2 className="text-base font-semibold text-gray-900 mb-1">Tahmini Performans Projeksiyonları</h2>
          <p className="text-xs text-gray-600 mb-4">Türkiye dijital reklam pazarındaki güncel benchmark’lara dayalı 2026 World Cup brand campaign projeksiyonları.</p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { label: 'YouTube Views',         value: activeOption === 'A' ? '8.2M' : '8.9M', sub: '@ ₺0.04–0.05 CPV' },
              { label: 'Programatik Impr.',     value: activeOption === 'A' ? '38M'  : '40M',  sub: '@ ₺7–9 CPM blended' },
              { label: 'Meta Reach',            value: activeOption === 'A' ? '11M'  : '10M',  sub: 'Türkiye 18–55E + futbol-affinity' },
              { label: 'TikTok Views',          value: activeOption === 'A' ? '6.5M' : '5.2M', sub: 'In-Feed + Spark Ads' },
            ].map((k, i) => (
              <div key={i} className="border border-gray-200 rounded p-4">
                <div className="text-[11px] uppercase tracking-wider text-gray-500">{k.label}</div>
                <div className="text-2xl font-bold text-gray-900 mt-1">{k.value}</div>
                <div className="text-[11px] text-gray-600 mt-1">{k.sub}</div>
              </div>
            ))}
            <div className="border border-gray-200 rounded p-4 col-span-2">
              <div className="text-[11px] uppercase tracking-wider text-gray-500">Toplam Kampanya Reach</div>
              <div className="text-2xl font-bold text-gray-900 mt-1">{activeOption === 'A' ? '24M+' : '22M+'} tekil kullanıcı</div>
              <div className="text-[11px] text-gray-600 mt-1">Türkiye’deki futbol-ilgili nüfusun ~%70’i</div>
            </div>
            <div className="border border-gray-200 rounded p-4 col-span-2">
              <div className="text-[11px] uppercase tracking-wider text-gray-500">Brand Lift Hedefi</div>
              <div className="text-2xl font-bold text-gray-900 mt-1">+8–12 pt Ad Recall</div>
              <div className="text-[11px] text-gray-600 mt-1">YouTube Brand Lift Study ile ölçülecek (organik)</div>
            </div>
          </div>
        </div>

        {/* ─────────────────────────────────────────────────────────────────── */}
        {/* DISCLAIMER                                                           */}
        {/* ─────────────────────────────────────────────────────────────────── */}
        <div className="border-t border-gray-200 pt-4">
          <p className="text-[11px] text-gray-600 leading-relaxed">
            <span className="font-semibold text-gray-900">Tahmini Projeksiyonlar & Esneklik Notu.</span> Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark’lara ve önceki turnuva dönemlerine (EURO 2024) dayalı tahmini projeksiyonlarla hazırlanmıştır. Knockout faz bütçeleri Türkiye’nin turnuvadaki gidişatına göre conditional olarak harcanır — geçemediği takdirde rezerv bütçe always-on retail SoV’a veya yıldız-oyuncu temalı creative’e kaydırılır. Maç saatleri (04:00–06:00 TR) nedeniyle sabah özet pencereleri beklenenden 2–3 kat daha kritik. CPM/CPV oranları açık artırma yoğunluğuna göre ±20% sapabilir.
          </p>
        </div>

      </div>{/* /captureRef */}
    </div>
  );
}
